"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommunityBubble = void 0;
var react_1 = __importDefault(require("react"));
require("./CommunityBubble.css");
var classnames_1 = __importDefault(require("classnames"));
var CommunityBubble = function (props) {
    var _a, _b, _c, _d;
    return (react_1.default.createElement("a", { className: (0, classnames_1.default)('dui-community-bubble', props.className), href: "https://decentraland.org/discord", target: "about:blank" },
        react_1.default.createElement("i", { className: "dui-community-bubble__icon" }),
        react_1.default.createElement("p", { className: "dui-community-bubble__text" },
            react_1.default.createElement("span", null, (_b = (_a = props.i18n) === null || _a === void 0 ? void 0 : _a.title) !== null && _b !== void 0 ? _b : 'Need Guidance?'),
            react_1.default.createElement("span", { className: "dui-community-bubble__text--bold" }, (_d = (_c = props.i18n) === null || _c === void 0 ? void 0 : _c.subtitle) !== null && _d !== void 0 ? _d : 'ASK THE COMMUNITY'))));
};
exports.CommunityBubble = CommunityBubble;
